import {inject, Injectable} from "@angular/core";
import {FundApiService} from "../generated-sources/api";
import {Observable} from "rxjs";
import {FundReport} from "../models/fund-report";
import {FundData} from "../models/fund-data";

@Injectable({
    providedIn: "root"
})
export class FundReportService {
    private readonly fundApiService = inject(FundApiService)

    constructor() {
    }

    public getFundReport(fundId: number, fundReportId: number): Observable<FundReport> {
        return this.fundApiService.getFundReport(fundId, fundReportId);
    }

    public createFundReport(fundId: number, report: FundReport): Observable<FundReport> {
        return this.fundApiService.createFundReport(fundId, report);
    }

    public updateFundReport(fundId: number, fundReportId: number, fundReport: FundReport, fundValuationId?: number, dealId?: number, dataset?: string): Observable<FundData> {
        return this.fundApiService.updateFundReport(fundId, fundReportId, {
            fundReport,
            fundValuationId,
            dealId,
            dataset
        });
    }

    public calculateFundReport(fundId: number, fundReportId: number, report: FundReport): Observable<FundReport> {
        return this.fundApiService.calculateFundReport(fundId, fundReportId, report);
    }

    public deleteFundReport(fundId: number, fundReportId: number): Observable<void> {
        return this.fundApiService.deleteFundReport(fundId, fundReportId);
    }
}
